import React from "react";
import { Field, ErrorMessage, FieldArray } from "formik";
import { Card, Button, Collapse, Col } from "react-bootstrap";
import DefaultButton from "../../../shared/components/DefaultButton";

const NotificationQuestions = ({ values, setFieldValue, collapse, setCollapse, isQuestionsEditable, allowAddRemove }) => {
  return (
    <Col md={12}>
      <Card className="mt-4">
        <Card.Header>
          <h5>
            <Button
              variant="link"
              onClick={() =>
                setCollapse((prev) => ({
                  ...prev,
                  section1: !prev.section1,
                }))
              }
              style={{ textDecoration: "none" }}
            >
              <i
                className={`fa ${
                  collapse.section1
                    ? "fa-angle-double-down"
                    : "fa-angle-double-right"
                }`}
                style={{
                  color: "#fa8c29",
                  marginRight: "6px",
                  fontSize: "13px",
                }}
              />
              <span className="form-label" style={{ color: "#000" }}>
                Notification Question
              </span>
            </Button>
          </h5>
        </Card.Header>

        <Collapse in={collapse.section1}>
          <div id="collapseOne">
            <Card.Body>
              <FieldArray name="questions">
                {({ push, remove }) => (
                  <>
                    {values.questions?.map((q, index) => (
                      <div key={index} className="border rounded p-3 mb-3">
                        <div className="row g-4">
                          {/* Hidden ref field (Q1, Q2, Q3) */}
                          <Field
                            type="hidden"
                            name={`questions.${index}.q_ref`}
                            value={`Q${index + 1}`}
                          />

                          <div className="col-md-3">
                            <label className="form-label">
                              Question <span className="error-text">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name={`questions.${index}.question`}
                              placeholder="Enter Question"
                              disabled={!isQuestionsEditable}
                            />
                            <span className="error-text">
                              <ErrorMessage
                                name={`questions.${index}.question`}
                              />
                            </span>
                          </div>

                          <div className="col-md-2">
                            <label className="form-label">
                              Answer Input Type <span className="error-text">*</span>
                            </label>
                            <Field
                              as="select"
                              name={`questions.${index}.q_type`}
                              className="form-control"
                              disabled={!isQuestionsEditable}
                            >
                              <option value="">Select Type</option>
                              <option value="text">Text</option>
                              <option value="options">Options</option>
                            </Field>
                            <ErrorMessage
                              name={`questions.${index}.q_type`}
                              component="div"
                              className="error-text"
                            />
                          </div>

                          {q.q_type === "options" && (
                            <div className="col-md-3">
                              <label className="form-label">
                                Options (comma separated){" "}
                                <span className="error-text">*</span>
                              </label>
                              <Field
                                className="form-control"
                                type="text"
                                name={`questions.${index}.q_options`}
                                placeholder="Yes,No,Maybe"
                                disabled={!isQuestionsEditable}
                              />
                              <span className="error-text">
                                <ErrorMessage
                                  name={`questions.${index}.q_options`}
                                />
                              </span>
                            </div>
                          )}

                          <div className="col-md-2 d-flex align-items-center">
                            <div className="form-check mt-4">
                              <Field
                                type="checkbox"
                                name={`questions.${index}.q_required`}
                                className="form-check-input"
                                disabled={!isQuestionsEditable}
                              />
                              <label className="form-check-label">
                                Required
                              </label>
                            </div>
                          </div>

                          {/* Remove button only if add/remove is allowed */}
                          <div className="col d-flex justify-content-end align-items-center">
                            {values.questions.length > 1 &&
                              allowAddRemove && (
                                <Button
                                  variant="danger"
                                  type="button"
                                  onClick={() => remove(index)}
                                >
                                  -
                                </Button>
                              )}
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Add button only if add/remove is allowed */}
                    {allowAddRemove && (
                      <Button
                        variant="success"
                        type="button"
                        onClick={() =>
                          push({
                            question: "",
                            q_type: "",
                            q_options: "",
                            q_required: false,
                            q_ref: `Q${values.questions.length + 1}`,
                          })
                        }
                        disabled={values.questions.length >= 3} // max 3 questions
                        style={{backgroundColor: "var(--color-primary-green)",borderColor: "var(--color-primary-green)",color: "#fff" }}
                      >
                        + Add Question
                      </Button>
                    )}
                  </>
                )}
              </FieldArray>
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </Col>
  );
};

export default NotificationQuestions;
